import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { deviceList } from "../../services/deviceService"

const DeviceStatus = () => {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);

  const handleClick = (device) => {
        navigate(`/device/${device.id}`, { state: { device } });
  };
  const getDeviceList = async () => {
          try {
            const token = localStorage.getItem("token");
            const data = await deviceList(token);
            if (!data.success) {
                alert(data.message);
                console.error("기기 디바이스 :", data);
                return;
            }
            console.log("기기 디바이스 목록:", data);
            setDevices(data.device); // 여기서도 filteredList 업데이트
        } catch (error) {
            console.error("기기 디바이스 목록 불러오기 실패:", error);
        }
    };

    useEffect(() => {
        getDeviceList();
    }, []);

    const getStatusText = (status) => {
        return status === 1 || status === "1" ? "정상" : "비정상";
    };

    const getMatchedText = (status) => {
        return status === 1 || status === "1" ? "설치됨" : "설치안됨";
    };
    
  return (
      <div className="equipment dashboard_box">
         <h4>장비상태</h4>
      <div className="equipmenttb table">
        <table>
          <colgroup>
            <col width="15%" />
            <col width="10%" />
            <col width="6%" />
            <col width="25%" />
            <col width="6%" />
            <col width="6%" />
          </colgroup>
          <thead>
              <tr>
                  <th scope="col">장비 ID</th>
                  <th scope="col">사용자</th>
                  <th scope="col">설치유무</th>
                  <th scope="col">설치위치</th>                                    
                  <th scope="col">플러그</th>
                  <th scope="col">스위치</th>
                 {/* <th scope="col">마지막 응답</th>*/}
              </tr>
          </thead>
          <tbody>
            {devices.map((device) => (
              <tr key={device.id} onClick={() => handleClick(device)} style={{ cursor: "pointer" }}>
                  <td scope="row" title={device.plug_id}>
			  {String(device.plug_id ?? "").replace(
			    /^DAWONDNS-B350N_NBX-\s*/,
			    ""
			  )}
		    </td>
                  <td>{device.name || '-'}</td>                  
                  <td>
                      <span
                          style={{
                              display: "inline-block",
                              width: "60px",
                              padding: "5px 0",
                              borderRadius: "3px",
                              color: "white",
                              backgroundColor:
                                  device.is_matched === 1 || device.is_matched === "1" ? "#1ba9ff" : "#ef4444",
                              textAlign: "center"
                          }}
                      >
                          {getMatchedText(device.is_matched)}
                      </span>
                  </td>
                  <td>{device.address || '-'}</td>
                  <td>
                      <span
                          style={{
                              display: "inline-block",
                              width: "60px",
                              padding: "5px 0",
                              borderRadius: "3px",
                              color: "white",
                              backgroundColor:
                                  device.plug_status === 1 || device.plug_status === "1" ? "#22c55e" : "#ef4444",
                              textAlign: "center"
                          }}
                      >
                          {getStatusText(device.plug_status)}
                      </span>
                  </td>
                  <td>
                      <span
                          style={{
                              display: "inline-block",
                              width: "60px",
                              padding: "5px 0",
                              borderRadius: "3px",
                              color: "white",
                              backgroundColor:
                                  device.swich_status === 1 || device.swich_status === "1" ? "#22c55e" : "#ef4444",
                              textAlign: "center"
                          }}
                      >
                          {getStatusText(device.swich_status)}
                      </span>
                  </td>                                        
                  {/*<td>{device.create_date}</td> */}
              </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeviceStatus;
